import React from 'react'
import { FormValidator } from '../form'
import { TextInput } from '../form-text'
import {
  MessageGetter,
  ValidationProps,
  Validatable
} from '../form/form-validator'
import { TextInputProps } from '../form-text/text-input'
import { css } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'

interface Props extends Partial<TextInputProps> {
  readonly value: string
  readonly onChange: (value: string) => void
  readonly getErrorMessage?: MessageGetter
  readonly validator?: (
    value: string,
    props: ValidationProps,
    ref: Validatable
  ) => boolean
  readonly id: string
}

interface State {
  readonly edit: boolean
  readonly value: string
}

export class EditableInput extends React.Component<Props, State> {
  public constructor(props) {
    super(props)
    this.state = {
      edit: false,
      value: props.value
    }
  }
  public componentWillReceiveProps(nextProps: Props) {
    if (nextProps.value !== this.props.value) {
      this.setState({ value: nextProps.value })
    }
  }
  public render() {
    const {
      onChange,
      id,
      getErrorMessage,
      validator,
      value: _originalValue,
      ...props
    } = this.props
    const { edit, value } = this.state
    return !edit ? (
      <span
        data-testid="editable-input-a"
        onClick={() => this.toggle()}
        className={css`
          &:hover {
            border-radius: 3px;
            border: 1px solid ${theme.color.neutral50};
          }
        `}
      >
        {value}
      </span>
    ) : (
      <FormValidator value={value}>
        {({ getFormFieldProps, formIsValid }) => {
          return (
            <TextInput
              data-testid="editable-input-b"
              type="text"
              autoFocus
              tabIndex={0}
              label=""
              renderLabel={() => undefined}
              value={value}
              onChange={this.update}
              {...props}
              {...getFormFieldProps({
                id,
                getErrorMessage,
                validator: validator
                  ? (props, ref) => validator(value, props, ref)
                  : undefined,
                onBlur: (e) => {
                  if (formIsValid) {
                    if (e.target.value !== this.props.value) {
                      onChange(e.target.value)
                    }
                    this.toggle()
                  }
                }
              })}
            />
          )
        }}
      </FormValidator>
    )
  }

  private toggle = () =>
    this.setState((prevState) => ({
      edit: !prevState.edit
    }))

  private update = (value: string) => this.setState({ value })
}
